module.exports = __webpack_public_path__ + "f29319d2ae769626b231c5dea47e1ea1.woff2";